import { Box, BoxProps } from '@mui/material';
import React from 'react';

export const stripHtml = (value: string): string =>
  value.replace(/<[^>]*>/g, '');

interface HtmlContentProps extends BoxProps {
  html: string;
}

export const HtmlContent = ({ html, ...props }: HtmlContentProps) => (
  <Box {...props} dangerouslySetInnerHTML={{ __html: html }} />
);
